import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreditCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 56,
	height: 56,
	viewBox: "0 0 56 56",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_9726:61542)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M50.4 46.2008C51.1732 46.2008 51.8046 45.5734 51.7563 44.8017C51.6021 42.3386 51.0418 39.9146 50.0949 37.6287C48.9692 34.911 47.3192 32.4416 45.2392 30.3616C43.1592 28.2816 40.6898 26.6316 37.9721 25.5059C35.6862 24.559 33.2622 23.9987 30.7991 23.8445C30.0274 23.7962 29.4 24.4276 29.4 25.2008L29.4 44.8008C29.4 45.574 30.0268 46.2008 30.8 46.2008H50.4Z",
				fill: "#FFDFA2"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M33.6001 40.5996L25.2 51.0993",
				stroke: "#031839",
				strokeWidth: 2.1,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 24.7867,
				cy: 51.3055,
				r: 2.71765,
				fill: "#031839"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M43.8123 52.2129L43.8123 49.0423C43.8123 38.7861 35.4979 30.4717 25.2417 30.4717V30.4717C14.9854 30.4717 6.67108 38.7861 6.67108 49.0423L6.67108 52.2129",
				stroke: "#031839",
				strokeWidth: 2.1,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M37.869 18.5496L12.5308 18.5496C10.0561 18.5496 8.0499 16.5435 8.0499 14.0687L8.0499 8.33047C8.04991 5.85576 10.0561 3.84961 12.5308 3.84961L37.869 3.84961C40.3438 3.84961 42.3499 5.85576 42.3499 8.33047L42.3499 14.0687C42.3499 16.5435 40.3438 18.5496 37.869 18.5496Z",
				stroke: "#031839",
				strokeWidth: 2.1
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.3999 10.9033L24.6106 12.7841L27.3612 9.80078",
				stroke: "#031839",
				strokeWidth: 1.68,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_9726:61542",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 56,
			height: 56,
			fill: "white"
		})
	}) })]
});
export default SvgCreditCheck;
